import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { environment } from '../../../environments/environment';
import { Icons } from '../../../shared/helpers/icons';

type AdminProduct = {
  title: string;
  description: string;
  icon: (typeof Icons)[keyof typeof Icons];
  route?: string;
  href?: string;
  external?: boolean;
  status?: string;
};

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterLink, LucideAngularModule],
  templateUrl: './home.component.html'
})
export class HomeComponent {
  icons = Icons;

  products: AdminProduct[] = [
    {
      title: 'Fleet',
      description: 'Manage trackers, transportation levels, layers, and fleet map configuration by building.',
      route: '/fleet',
      icon: Icons.Bus
    },
    // {
    //   title: '360 Bulk Upload',
    //   description: 'Upload streetview photo batches and match images to level GeoJSON points.',
    //   route: '/360-bulk-upload',
    //   icon: Icons.Fullscreen
    // },
    // {
    //   title: 'Maps',
    //   description: 'Open map management tools for building map data and indoor mapping workflows.',
    //   route: '/maps',
    //   icon: Icons.MapPin,
    //   status: 'Beta'
    // },
    {
      title: 'Admin Identity',
      description: 'Manage admin users, access, and identity configuration.',
      href: `${environment.identityUrl}/admin/users`,
      icon: Icons.FileUser,
      external: true
    },
    {
      title: 'nSide Platform',
      description: 'Open the main nSide platform for standard building operations.',
      href: environment.nSidePlatformUrl,
      icon: Icons.DoorOpen,
      external: true
    }
  ];
}
